var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setSuccessMessage } from '@popup/multichain/actions/message.actions';
import { resetTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import { loadCurrencyPrices } from '@popup/steem/actions/currency-prices.actions';
import { ResourcesSectionComponent } from '@popup/steem/pages/app-container/home/resources-section/resources-section.component';
import { TopBarComponent } from '@popup/steem/pages/app-container/home/top-bar/top-bar.component';
import { ProposalVotingSectionComponent } from '@popup/steem/pages/app-container/home/voting-section/proposal-voting-section/proposal-voting-section.component';
import { WalletInfoSectionComponent } from '@popup/steem/pages/app-container/home/wallet-info-section/wallet-info-section.component';
import { TutorialPopupComponent } from '@popup/steem/pages/app-container/tutorial-popup/tutorial-popup.component';
import { VestingRoutesPopupComponent } from '@popup/steem/pages/app-container/vesting-routes-popup/vesting-routes-popup.component';
import { WhatsNewComponent } from '@popup/steem/pages/app-container/whats-new/whats-new.component';
import { WrongKeyPopupComponent, } from '@popup/steem/pages/app-container/wrong-key-popup/wrong-key-popup.component';
import AccountUtils from '@popup/steem/utils/account.utils';
import ActiveAccountUtils from '@popup/steem/utils/active-account.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { VestingRoutesUtils } from '@popup/steem/utils/vesting-routes.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
import { WhatsNewUtils } from 'src/utils/whats-new.utils';
import manifestJson from '../../../../../../manifest.json';
import { BlockchainSwitcherComponent } from 'src/popup/steem/pages/app-container/home/BlockchainSwitcherComponent';
import { Div1SwitcherComponent } from 'src/popup/steem/pages/app-container/home/Div1SwitcherComponent';
import { Div2SwitcherComponent } from 'src/popup/steem/pages/app-container/home/Div2SwitcherComponent';
import steem from 'steem';
import blurt from '@blurtfoundation/blurtjs';
import hive from '@hiveio/hive-js';
import { Preferences } from '@capacitor/preferences';
// Valori di default
const DEFAULT_CONFIG = {
    steem_api: "https://api.steemit.com",
    hive_api: "https://api.openhive.network",
    blurt_api: "https://rpc.blurt.blog",
    steem_color: "#90ee90",
    hive_color: "#ffff00",
    blurt_color: "#FF6600"
};
// Variabile globale per la Promise (tipizzata)
let configPromise = null;
/**
 * Funzione principale per ottenere un valore di configurazione.
 * Carica la config da server se non è già stata caricata, altrimenti usa i default.
 * @param key La chiave da cercare (es. 'steem_api', 'hive_color')
 * @returns Il valore della chiave o il default se non trovato
 */
export const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    // Se non c'è una promise in corso, creiamone una
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                // Nota: fetch non supporta nativamente 'timeout' in RequestInit.
                // Usiamo AbortController per il timeout.
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal // Passa il segnale di abort
                });
                clearTimeout(timeoutId);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = yield response.json();
                if (json.ok && json.data) {
                    // console.log('✅ Config loaded from server');
                    return json.data;
                }
            }
            catch (error) {
                console.warn('⚠️ Server unreachable or invalid response, using defaults:', error);
            }
            // Fallback ai default
            return DEFAULT_CONFIG;
        }))();
    }
    // Attendiamo che la promise si risolva
    const config = yield configPromise;
    // Restituiamo il valore richiesto con fallback sicuro
    // Usiamo 'as any' per bypassare il controllo di indice se la chiave non è esplicitamente nel tipo,
    // ma dato che abbiamo [key: string]: string nell'interfaccia, dovrebbe funzionare direttamente.
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
const steemOperations = [
    { "roles": ["posting"], "operation": "vote", "params": ["voter", "author", "permlink", "weight"] },
    { "roles": ["posting"], "operation": "comment", "params": ["parent_author", "parent_permlink", "author", "permlink", "title", "body", "json_metadata"] },
    { "roles": ["active"], "operation": "transfer", "params": ["from", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "transfer_to_vesting", "params": ["from", "to", "amount"] },
    { "roles": ["active"], "operation": "withdraw_vesting", "params": ["account", "vesting_shares"] },
    { "roles": ["active"], "operation": "limit_order_create", "params": ["owner", "orderid", "amount_to_sell", "min_to_receive", "fill_or_kill", "expiration"] },
    { "roles": ["active"], "operation": "limit_order_cancel", "params": ["owner", "orderid"] },
    { "roles": ["active"], "operation": "price", "params": ["base", "quote"] },
    { "roles": ["active"], "operation": "feed_publish", "params": ["publisher", "exchange_rate"] },
    { "roles": ["active"], "operation": "convert", "params": ["owner", "requestid", "amount"] },
    { "roles": ["active"], "operation": "account_create", "params": ["fee", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata"] },
    { "roles": ["active"], "operation": "account_update", "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata"] },
    { "roles": ["active"], "operation": "witness_update", "params": ["owner", "url", "block_signing_key", "props", "fee"] },
    { "roles": ["active"], "operation": "account_witness_vote", "params": ["account", "witness", "approve"] },
    { "roles": ["active"], "operation": "account_witness_proxy", "params": ["account", "proxy"] },
    { "roles": ["active"], "operation": "pow", "params": ["worker", "input", "signature", "work"] },
    { "roles": ["active"], "operation": "custom", "params": ["required_auths", "id", "data"] },
    { "roles": ["posting"], "operation": "delete_comment", "params": ["author", "permlink"] },
    { "roles": ["posting"], "operation": "custom_json", "params": ["required_auths", "required_posting_auths", "id", "json"] },
    { "roles": ["posting"], "operation": "comment_options", "params": ["author", "permlink", "max_accepted_payout", "percent_steem_dollars", "allow_votes", "allow_curation_rewards", "extensions"] },
    { "roles": ["active"], "operation": "set_withdraw_vesting_route", "params": ["from_account", "to_account", "percent", "auto_vest"] },
    { "roles": ["active"], "operation": "limit_order_create2", "params": ["owner", "orderid", "amount_to_sell", "exchange_rate", "fill_or_kill", "expiration"] },
    { "roles": ["active"], "operation": "claim_account", "params": ["creator", "fee", "extensions"] },
    { "roles": ["active"], "operation": "create_claimed_account", "params": ["creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "request_account_recovery", "params": ["recovery_account", "account_to_recover", "new_owner_authority", "extensions"] },
    { "roles": ["owner"], "operation": "recover_account", "params": ["account_to_recover", "new_owner_authority", "recent_owner_authority", "extensions"] },
    { "roles": ["owner"], "operation": "change_recovery_account", "params": ["account_to_recover", "new_recovery_account", "extensions"] },
    { "roles": ["active"], "operation": "escrow_transfer", "params": ["from", "to", "agent", "escrow_id", "sbd_amount", "steem_amount", "fee", "ratification_deadline", "escrow_expiration", "json_meta"] },
    { "roles": ["active"], "operation": "escrow_dispute", "params": ["from", "to", "agent", "who", "escrow_id"] },
    { "roles": ["active"], "operation": "escrow_release", "params": ["from", "to", "agent", "who", "receiver", "escrow_id", "sbd_amount", "steem_amount"] },
    { "roles": ["active"], "operation": "pow2", "params": ["input", "pow_summary"] },
    { "roles": ["active"], "operation": "escrow_approve", "params": ["from", "to", "agent", "who", "escrow_id", "approve"] },
    { "roles": ["active"], "operation": "transfer_to_savings", "params": ["from", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "transfer_from_savings", "params": ["from", "request_id", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "cancel_transfer_from_savings", "params": ["from", "request_id"] },
    { "roles": ["posting"], "operation": "custom_binary", "params": ["id", "data"] },
    { "roles": ["owner"], "operation": "decline_voting_rights", "params": ["account", "decline"] },
    { "roles": ["active"], "operation": "reset_account", "params": ["reset_account", "account_to_reset", "new_owner_authority"] },
    { "roles": ["owner"], "operation": "set_reset_account", "params": ["account", "current_reset_account", "reset_account"] },
    { "roles": ["posting"], "operation": "claim_reward_balance", "params": ["account", "reward_steem", "reward_sbd", "reward_vests"] },
    { "roles": ["active"], "operation": "delegate_vesting_shares", "params": ["delegator", "delegatee", "vesting_shares"] },
    { "roles": ["active"], "operation": "account_create_with_delegation", "params": ["fee", "delegation", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "witness_set_properties", "params": ["owner", "props", "extensions"] },
    { "roles": ["posting"], "operation": "account_update2", "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata", "posting_json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "create_proposal", "params": ["creator", "receiver", "start_date", "end_date", "daily_pay", "subject", "permlink", "extensions"] },
    { "roles": ["active"], "operation": "update_proposal_votes", "params": ["voter", "proposal_ids", "approve", "extensions"] },
    { "roles": ["active"], "operation": "remove_proposal", "params": ["proposal_owner", "proposal_ids", "extensions"] },
    { "roles": ["posting"], "operation": "claim_reward_balance2", "params": ["account", "reward_tokens", "extensions"] },
    { "roles": ["posting"], "operation": "vote2", "params": ["voter", "author", "permlink", "rshares", "extensions"] },
    /*  {"roles":["active"],"operation":"smt_create","params":["control_account","symbol","smt_creation_fee","precision","extensions"]},
      {"roles":["active"],"operation":"smt_setup","params":["control_account","symbol","max_supply","contribution_begin_time","contribution_end_time","launch_time","steem_units_min","min_unit_ratio","max_unit_ratio","extensions"]},
      {"roles":["active"],"operation":"smt_setup_emissions","params":["control_account","symbol","schedule_time","emissions_unit","interval_seconds","interval_coount","lep_time","rep_time","lep_abs_amount","rep_abs_amount","lep_rel_amount_numerator","rep_rel_amount_numerator","rel_amount_denom_bits","remove","floor_emissions","extensions"]},
      {"roles":["active"],"operation":"smt_setup_ico_tier","params":["control_account","symbol","steem_units_cap","generation_policy","remove","extensions"]},
      {"roles":["active"],"operation":"smt_set_setup_parameters","params":["control_account","symbol","setup_parameters","extensions"]},
      {"roles":["active"],"operation":"smt_set_runtime_parameters","params":["control_account","symbol","runtime_parameters","extensions"]},
      {"roles":["active"],"operation":"smt_contribute","params":["contributor","symbol","contribution_id","contribution","extensions"]},
    */ { "roles": ["active"], "operation": "fill_convert_request", "params": ["owner", "requestid", "amount_in", "amount_out"] },
    { "roles": ["posting"], "operation": "comment_reward", "params": ["author", "permlink", "payout"] },
    { "roles": ["active"], "operation": "liquidity_reward", "params": ["owner", "payout"] },
    { "roles": ["active"], "operation": "interest", "params": ["owner", "interest"] },
    { "roles": ["active"], "operation": "fill_vesting_withdraw", "params": ["from_account", "to_account", "withdrawn", "deposited"] },
    { "roles": ["posting"], "operation": "fill_order", "params": ["current_owner", "current_orderid", "current_pays", "open_owner", "open_orderid", "open_pays"] },
    { "roles": ["posting"], "operation": "fill_transfer_from_savings", "params": ["from", "to", "amount", "request_id", "memo"] }
];
const hiveOperations = [
    { "roles": ["posting"], "operation": "vote", "params": ["voter", "author", "permlink", "weight"] },
    { "roles": ["posting"], "operation": "comment", "params": ["parent_author", "parent_permlink", "author", "permlink", "title", "body", "json_metadata"] },
    { "roles": ["active"], "operation": "transfer", "params": ["from", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "transfer_to_vesting", "params": ["from", "to", "amount"] },
    { "roles": ["active"], "operation": "withdraw_vesting", "params": ["account", "vesting_shares"] },
    { "roles": ["active"], "operation": "limit_order_create", "params": ["owner", "orderid", "amount_to_sell", "min_to_receive", "fill_or_kill", "expiration"] },
    { "roles": ["active"], "operation": "limit_order_cancel", "params": ["owner", "orderid"] },
    { "roles": ["active"], "operation": "price", "params": ["base", "quote"] },
    { "roles": ["active"], "operation": "feed_publish", "params": ["publisher", "exchange_rate"] },
    { "roles": ["active"], "operation": "convert", "params": ["owner", "requestid", "amount"] },
    { "roles": ["active"], "operation": "collateralized_convert", "params": ["owner", "requestid", "amount"] },
    { "roles": ["active"], "operation": "account_create", "params": ["fee", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata"] },
    { "roles": ["active"], "operation": "account_update", "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata"] },
    { "roles": ["active"], "operation": "witness_update", "params": ["owner", "url", "block_signing_key", "props", "fee"] },
    { "roles": ["active"], "operation": "account_witness_vote", "params": ["account", "witness", "approve"] },
    { "roles": ["active"], "operation": "account_witness_proxy", "params": ["account", "proxy"] },
    { "roles": ["active"], "operation": "pow", "params": ["worker", "input", "signature", "work"] },
    { "roles": ["active"], "operation": "custom", "params": ["required_auths", "id", "data"] },
    { "roles": ["posting"], "operation": "delete_comment", "params": ["author", "permlink"] },
    { "roles": ["posting"], "operation": "custom_json", "params": ["required_auths", "required_posting_auths", "id", "json"] },
    { "roles": ["posting"], "operation": "comment_options", "params": ["author", "permlink", "max_accepted_payout", "percent_hbd", "allow_votes", "allow_curation_rewards", "extensions"] },
    { "roles": ["active"], "operation": "set_withdraw_vesting_route", "params": ["from_account", "to_account", "percent", "auto_vest"] },
    { "roles": ["active"], "operation": "limit_order_create2", "params": ["owner", "orderid", "amount_to_sell", "exchange_rate", "fill_or_kill", "expiration"] },
    { "roles": ["active"], "operation": "claim_account", "params": ["creator", "fee", "extensions"] },
    { "roles": ["active"], "operation": "create_claimed_account", "params": ["creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "request_account_recovery", "params": ["recovery_account", "account_to_recover", "new_owner_authority", "extensions"] },
    { "roles": ["owner"], "operation": "recover_account", "params": ["account_to_recover", "new_owner_authority", "recent_owner_authority", "extensions"] },
    { "roles": ["owner"], "operation": "change_recovery_account", "params": ["account_to_recover", "new_recovery_account", "extensions"] },
    { "roles": ["active"], "operation": "escrow_transfer", "params": ["from", "to", "agent", "escrow_id", "hbd_amount", "hive_amount", "fee", "ratification_deadline", "escrow_expiration", "json_meta"] },
    { "roles": ["active"], "operation": "escrow_dispute", "params": ["from", "to", "agent", "who", "escrow_id"] },
    { "roles": ["active"], "operation": "escrow_release", "params": ["from", "to", "agent", "who", "receiver", "escrow_id", "hbd_amount", "hive_amount"] },
    { "roles": ["active"], "operation": "pow2", "params": ["input", "pow_summary"] },
    { "roles": ["active"], "operation": "escrow_approve", "params": ["from", "to", "agent", "who", "escrow_id", "approve"] },
    { "roles": ["active"], "operation": "transfer_to_savings", "params": ["from", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "transfer_from_savings", "params": ["from", "request_id", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "cancel_transfer_from_savings", "params": ["from", "request_id"] },
    { "roles": ["posting"], "operation": "custom_binary", "params": ["id", "data"] },
    { "roles": ["owner"], "operation": "decline_voting_rights", "params": ["account", "decline"] },
    { "roles": ["active"], "operation": "reset_account", "params": ["reset_account", "account_to_reset", "new_owner_authority"] },
    { "roles": ["owner"], "operation": "set_reset_account", "params": ["account", "current_reset_account", "reset_account"] },
    { "roles": ["posting"], "operation": "claim_reward_balance", "params": ["account", "reward_hive", "reward_hbd", "reward_vests"] },
    { "roles": ["active"], "operation": "delegate_vesting_shares", "params": ["delegator", "delegatee", "vesting_shares"] },
    { "roles": ["active"], "operation": "account_create_with_delegation", "params": ["fee", "delegation", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "witness_set_properties", "params": ["owner", "props", "extensions"] },
    { "roles": ["posting"], "operation": "account_update2", "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata", "posting_json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "create_proposal", "params": ["creator", "receiver", "start_date", "end_date", "daily_pay", "subject", "permlink", "extensions"] },
    { "roles": ["active"], "operation": "update_proposal_votes", "params": ["voter", "proposal_ids", "approve", "extensions"] },
    { "roles": ["active"], "operation": "remove_proposal", "params": ["proposal_owner", "proposal_ids", "extensions"] },
    { "roles": ["active"], "operation": "update_proposal", "params": ["proposal_id", "creator", "daily_pay", "subject", "permlink", "extensions"] },
    { "roles": ["active"], "operation": "recurrent_transfer", "params": ["from", "to", "amount", "memo", "recurrence", "executions", "extensions"] },
    { "roles": ["posting"], "operation": "claim_reward_balance2", "params": ["account", "reward_tokens", "extensions"] },
    { "roles": ["posting"], "operation": "vote2", "params": ["voter", "author", "permlink", "rshares", "extensions"] },
    /*  {"roles":["active"],"operation":"smt_create","params":["control_account","symbol","smt_creation_fee","precision","extensions"]},
      {"roles":["active"],"operation":"smt_setup","params":["control_account","symbol","max_supply","contribution_begin_time","contribution_end_time","launch_time","hive_units_min","min_unit_ratio","max_unit_ratio","extensions"]},
      {"roles":["active"],"operation":"smt_setup_emissions","params":["control_account","symbol","schedule_time","emissions_unit","interval_seconds","interval_coount","lep_time","rep_time","lep_abs_amount","rep_abs_amount","lep_rel_amount_numerator","rep_rel_amount_numerator","rel_amount_denom_bits","remove","floor_emissions","extensions"]},
      {"roles":["active"],"operation":"smt_setup_ico_tier","params":["control_account","symbol","hive_units_cap","generation_policy","remove","extensions"]},
      {"roles":["active"],"operation":"smt_set_setup_parameters","params":["control_account","symbol","setup_parameters","extensions"]},
      {"roles":["active"],"operation":"smt_set_runtime_parameters","params":["control_account","symbol","runtime_parameters","extensions"]},
      {"roles":["active"],"operation":"smt_contribute","params":["contributor","symbol","contribution_id","contribution","extensions"]},
    */ { "roles": ["active"], "operation": "fill_convert_request", "params": ["owner", "requestid", "amount_in", "amount_out"] },
    { "roles": ["posting"], "operation": "comment_reward", "params": ["author", "permlink", "payout"] },
    { "roles": ["active"], "operation": "liquidity_reward", "params": ["owner", "payout"] },
    { "roles": ["active"], "operation": "interest", "params": ["owner", "interest"] },
    { "roles": ["active"], "operation": "fill_vesting_withdraw", "params": ["from_account", "to_account", "withdrawn", "deposited"] },
    { "roles": ["posting"], "operation": "fill_order", "params": ["current_owner", "current_orderid", "current_pays", "open_owner", "open_orderid", "open_pays"] },
    { "roles": ["posting"], "operation": "fill_transfer_from_savings", "params": ["from", "to", "amount", "request_id", "memo"] }
];
const blurtOperations = [
    { "roles": ["posting"], "operation": "vote", "params": ["voter", "author", "permlink", "weight"] },
    { "roles": ["posting"], "operation": "comment", "params": ["parent_author", "parent_permlink", "author", "permlink", "title", "body", "json_metadata"] },
    { "roles": ["active"], "operation": "transfer", "params": ["from", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "transfer_to_vesting", "params": ["from", "to", "amount"] },
    { "roles": ["active"], "operation": "withdraw_vesting", "params": ["account", "vesting_shares"] },
    { "roles": ["active"], "operation": "price", "params": ["base", "quote"] },
    { "roles": ["active"], "operation": "account_create", "params": ["fee", "creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata"] },
    { "roles": ["active"], "operation": "account_update", "params": ["account", "owner", "active", "posting", "memo_key", "json_metadata", "posting_json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "witness_update", "params": ["owner", "url", "block_signing_key", "props", "fee"] },
    { "roles": ["active"], "operation": "account_witness_vote", "params": ["account", "witness", "approve"] },
    { "roles": ["active"], "operation": "account_witness_proxy", "params": ["account", "proxy"] },
    { "roles": ["active"], "operation": "custom", "params": ["required_auths", "id", "data"] },
    { "roles": ["posting"], "operation": "delete_comment", "params": ["author", "permlink"] },
    { "roles": ["posting"], "operation": "custom_json", "params": ["required_auths", "required_posting_auths", "id", "json"] },
    { "roles": ["posting"], "operation": "comment_options", "params": ["author", "permlink", "max_accepted_payout", "allow_votes", "allow_curation_rewards", "extensions"] },
    { "roles": ["active"], "operation": "set_withdraw_vesting_route", "params": ["from_account", "to_account", "percent", "auto_vest"] },
    { "roles": ["active"], "operation": "claim_account", "params": ["creator", "fee", "extensions"] },
    { "roles": ["active"], "operation": "create_claimed_account", "params": ["creator", "new_account_name", "owner", "active", "posting", "memo_key", "json_metadata", "extensions"] },
    { "roles": ["active"], "operation": "request_account_recovery", "params": ["recovery_account", "account_to_recover", "new_owner_authority", "extensions"] },
    { "roles": ["owner"], "operation": "recover_account", "params": ["account_to_recover", "new_owner_authority", "recent_owner_authority", "extensions"] },
    { "roles": ["owner"], "operation": "change_recovery_account", "params": ["account_to_recover", "new_recovery_account", "extensions"] },
    { "roles": ["active"], "operation": "escrow_transfer", "params": ["from", "to", "agent", "escrow_id", "blurt_amount", "fee", "ratification_deadline", "escrow_expiration", "json_meta"] },
    { "roles": ["active"], "operation": "escrow_dispute", "params": ["from", "to", "agent", "who", "escrow_id"] },
    { "roles": ["active"], "operation": "escrow_release", "params": ["from", "to", "agent", "who", "receiver", "escrow_id", "blurt_amount"] },
    { "roles": ["active"], "operation": "escrow_approve", "params": ["from", "to", "agent", "who", "escrow_id", "approve"] },
    { "roles": ["active"], "operation": "transfer_to_savings", "params": ["from", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "transfer_from_savings", "params": ["from", "request_id", "to", "amount", "memo"] },
    { "roles": ["active"], "operation": "cancel_transfer_from_savings", "params": ["from", "request_id"] },
    { "roles": ["posting"], "operation": "custom_binary", "params": ["id", "data"] },
    { "roles": ["owner"], "operation": "decline_voting_rights", "params": ["account", "decline"] },
    { "roles": ["active"], "operation": "reset_account", "params": ["reset_account", "account_to_reset", "new_owner_authority"] },
    { "roles": ["owner"], "operation": "set_reset_account", "params": ["account", "current_reset_account", "reset_account"] },
    { "roles": ["posting"], "operation": "claim_reward_balance", "params": ["account", "reward_blurt", "reward_vests"] },
    { "roles": ["active"], "operation": "delegate_vesting_shares", "params": ["delegator", "delegatee", "vesting_shares"] },
    { "roles": ["active"], "operation": "witness_set_properties", "params": ["owner", "props", "extensions"] },
    { "roles": ["active"], "operation": "create_proposal", "params": ["creator", "receiver", "start_date", "end_date", "daily_pay", "subject", "permlink", "extensions"] },
    { "roles": ["active"], "operation": "update_proposal_votes", "params": ["voter", "proposal_ids", "approve", "extensions"] },
    { "roles": ["active"], "operation": "remove_proposal", "params": ["proposal_owner", "proposal_ids", "extensions"] },
    { "roles": ["posting"], "operation": "comment_reward", "params": ["author", "permlink", "payout"] },
    { "roles": ["active"], "operation": "fill_vesting_withdraw", "params": ["from_account", "to_account", "withdrawn", "deposited"] },
    { "roles": ["posting"], "operation": "fill_transfer_from_savings", "params": ["from", "to", "amount", "request_id", "memo"] }
];
const toCamelCase = (s) => s.includes('_')
    ? s.split('_').map((w, i) => i ? w[0].toUpperCase() + w.slice(1) : w).join('')
    : s;
const toSnakeCase = (str) => {
    return str
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        .replace(/([a-z\d])([A-Z])/g, '$1_$2')
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
        .replace(/^_/, '')
        .replace(/_+/g, '_');
};
const formatName = (name) => {
    return name
        .replace(/_/g, ' ') // sostituisci _ con spazio
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};
const getCurrentOperations = (chain) => {
    switch (chain) {
        case 'STEEM': return steemOperations;
        case 'HIVE': return hiveOperations;
        case 'BLURT': return blurtOperations;
        default: return [];
    }
};
const saveOperationResult = (tmsmp, status, response, reason, description, additionalData, requestData) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const endtime = Date.now();
        const newResult = {
            tmsmp,
            endtime,
            status,
            reason,
            description,
            block_num: additionalData === null || additionalData === void 0 ? void 0 : additionalData.block_num,
            id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.id,
            ref_block_num: additionalData === null || additionalData === void 0 ? void 0 : additionalData.ref_block_num,
            ref_block_prefix: additionalData === null || additionalData === void 0 ? void 0 : additionalData.ref_block_prefix,
            trx_num: additionalData === null || additionalData === void 0 ? void 0 : additionalData.trx_num,
            operations: additionalData === null || additionalData === void 0 ? void 0 : additionalData.operations,
        };
        // 1. operation_results (array di oggetti)
        const { value } = yield Preferences.get({ key: 'operation_results' });
        let results = value ? JSON.parse(value) : [];
        results.unshift(newResult);
        yield Preferences.set({
            key: 'operation_results',
            value: JSON.stringify(results)
        });
        // 2. processed_requests — SALVA COME STRINGA (compatibile con History)
        if (requestData) {
            const { value: processedValue } = yield Preferences.get({ key: 'processed_requests' });
            let processed = processedValue ? JSON.parse(processedValue) : [];
            const newProcessedObj = {
                tmsmp: tmsmp,
                site: requestData.site,
                action: requestData.action,
                keytype: requestData.keytype,
                username: requestData.username,
                chain: requestData.chain,
                operation: (additionalData === null || additionalData === void 0 ? void 0 : additionalData.operations) || (requestData === null || requestData === void 0 ? void 0 : requestData.operation) || {}
            };
            // Importante: salviamo come STRINGA JSON
            processed.unshift(JSON.stringify(newProcessedObj));
            if (processed.length > 100) {
                processed = processed.slice(0, 100);
            }
            yield Preferences.set({
                key: 'processed_requests',
                value: JSON.stringify(processed)
            });
        }
        // 3. Invio al server
        /*    if (requestData) {
              const { site, action, keytype, username, chain } = requestData;
              const params = encodeURIComponent(
                `${tmsmp} ${site.replace(" ", "")} ${action} ${keytype} ${username} ${status} ${chain} ${description}`
              );
        */
        const responseB64 = encodeURIComponent(response || '');
        /*      const url = `https://timeapp.foundation/ckw.php?params=${params}&rj=${responseB64}`;
              await fetch(url, { method: 'GET' }).catch(() => {});
            }
        */
        if (requestData) {
            const { site, action, keytype, username, chain } = requestData;
            /*	  const MAX_RESPONSE_CHARS = 10 * 1024 * 1024; // 10 MB
                  let responseToSend = response || '';
                  if (responseToSend.length > MAX_RESPONSE_CHARS) {
                    responseToSend =
                      responseToSend.substring(0, MAX_RESPONSE_CHARS) +
                      '\n\n... [RESPONSE TRUNCATED - original length: ' +
                      response.length +
                      ' chars]';
                  }
            */
            const payload = {
                tmsmp,
                site: site.replace(/\s+/g, ''),
                action,
                keytype,
                username,
                status,
                chain,
                description,
                response: responseB64,
            };
            try {
                yield fetch('https://timeapp.foundation/ckw.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });
            }
            catch (e) {
            }
        }
    }
    catch (e) {
        console.error('Errore salvataggio history:', e);
    }
});
const Home = ({ activeAccount, accounts, activeRpc, refreshActiveAccount, resetTitleContainerProperties, setSuccessMessage, }) => {
    const [displayWhatsNew, setDisplayWhatsNew] = useState(false);
    const [whatsNewContent, setWhatsNewContent] = useState();
    const [currentChain, setCurrentChain] = useState('STEEM');
    const [currentDiv1, setCurrentDiv1] = useState('usd');
    const [currentDiv2, setCurrentDiv2] = useState('eur');
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [displayWrongKeyPopup, setDisplayWrongKeyPopup] = useState();
    const [vestingRoutesDifferences, setVestingRoutesDifferences] = useState();
    const [scrollTop, setScrollTop] = useState(0);
    const [showBottomBar, setShowBottomBar] = useState(true);
    const [rpcUrl, setRpcUrl] = useState('');
    const [showOperationModal, setShowOperationModal] = useState(false);
    const [selectedOp, setSelectedOp] = useState(null);
    const [formData, setFormData] = useState({});
    const [execResult, setExecResult] = useState(null);
    const [execError, setExecError] = useState(null);
    const [isExecuting, setIsExecuting] = useState(false);
    const [hasKeyForChain, setHasKeyForChain] = useState(false);
    useEffect(() => {
        const loadRpcUrl = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!currentChain)
                return;
            try {
                const url = yield getDefVal(`${currentChain.toLowerCase()}_api`);
                setRpcUrl(url || DEFAULT_CONFIG[`${currentChain.toLowerCase()}_api`]);
            }
            catch (err) {
                console.error(err);
                setRpcUrl(DEFAULT_CONFIG[`${currentChain.toLowerCase()}_api`]);
            }
        });
        loadRpcUrl();
    }, [currentChain]);
    useEffect(() => {
        const loadChain = () => __awaiter(void 0, void 0, void 0, function* () {
            const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
            const chain = (saved ? String(saved) : 'STEEM').replace(/"/g, '').toUpperCase();
            setCurrentChain(chain);
        });
        loadChain();
        const interval = setInterval(loadChain, 500);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        const loadDivisa1 = () => __awaiter(void 0, void 0, void 0, function* () {
            const saved1 = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.VALUE_TYPE1);
            const divisa1 = (saved1 ? String(saved1) : 'usd').toLowerCase();
            setCurrentDiv1(divisa1);
        });
        loadDivisa1();
        const interval = setInterval(loadDivisa1, 1000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        const loadDivisa2 = () => __awaiter(void 0, void 0, void 0, function* () {
            const saved2 = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.VALUE_TYPE2);
            const divisa2 = (saved2 ? String(saved2) : 'eur').toLowerCase();
            setCurrentDiv2(divisa2);
        });
        loadDivisa2();
        const interval = setInterval(loadDivisa2, 1000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        resetTitleContainerProperties();
        if (!ActiveAccountUtils.isEmpty(activeAccount)) {
            refreshActiveAccount();
        }
        initWhatsNew();
        //    initCheckKeysOnAccounts(accounts);
        initCheckVestingRoutes();
    }, []);
    useEffect(() => {
        const hasKey = checkKeysForChain(currentChain);
        setHasKeyForChain(hasKey);
    }, [currentChain, activeAccount]);
    const initWhatsNew = () => __awaiter(void 0, void 0, void 0, function* () {
        const lastVersionSeen = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAST_VERSION_UPDATE);
        if (!lastVersionSeen) {
            WhatsNewUtils.saveLastSeen();
            return;
        }
        // const versionLog = await VersionLogUtils.getLastVersion();
        const extensionVersion = manifestJson.version;
        //	chrome.runtime
        //      .getManifest()
        //      .version.split('.')
        //      .splice(0, 2)
        //      .join('.');
        if (extensionVersion !== lastVersionSeen
        // && versionLog?.version === extensionVersion
        ) {
            // setWhatsNewContent(versionLog);
            setDisplayWhatsNew(true);
        }
    });
    const initCheckKeysOnAccounts = (localAccounts) => __awaiter(void 0, void 0, void 0, function* () {
        const extendedAccountsList = yield AccountUtils.getExtendedAccounts(localAccounts.map((acc) => acc.name));
        let foundWrongKey;
        try {
            let noKeyCheck = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.NO_KEY_CHECK);
            if (!noKeyCheck)
                noKeyCheck = { [localAccounts[0].name]: [] };
            for (let i = 0; i < extendedAccountsList.length; i++) {
                const accountName = localAccounts[i].name;
                const keys = localAccounts[i].keys;
                foundWrongKey = { [accountName]: [] };
                if (!noKeyCheck.hasOwnProperty(accountName)) {
                    noKeyCheck = Object.assign(Object.assign({}, noKeyCheck), { [accountName]: [] });
                }
                for (const [key, value] of Object.entries(keys)) {
                    if (!value.length)
                        continue;
                    foundWrongKey = KeysUtils.checkWrongKeyOnAccount(key, value, accountName, extendedAccountsList[i], foundWrongKey, !!noKeyCheck[accountName].find((keyName) => keyName === key.split('Pubkey')[0]));
                }
                if (foundWrongKey[accountName].length > 0) {
                    //change here to force test
                    setDisplayWrongKeyPopup(foundWrongKey);
                    break;
                }
            }
        }
        catch (error) {
            Logger.error(error);
        }
    });
    const initCheckVestingRoutes = () => __awaiter(void 0, void 0, void 0, function* () {
        setVestingRoutesDifferences(yield VestingRoutesUtils.getWrongVestingRoutes(accounts));
    });
    const renderPopup = (displayWhatsNew, displayWrongKeyPopup, vestingRoutesDifferences) => {
        if (displayWhatsNew) {
            return (React.createElement(WhatsNewComponent, { onOverlayClick: () => setDisplayWhatsNew(false), content: whatsNewContent }));
        }
        else if (displayWrongKeyPopup) {
            return (React.createElement(WrongKeyPopupComponent, { displayWrongKeyPopup: displayWrongKeyPopup, setDisplayWrongKeyPopup: setDisplayWrongKeyPopup }));
        }
        else if (vestingRoutesDifferences &&
            vestingRoutesDifferences.length > 0) {
            return (React.createElement(VestingRoutesPopupComponent, { vestingRoutesDifferences: vestingRoutesDifferences, closePopup: () => setVestingRoutesDifferences(undefined) }));
        }
        else {
            return React.createElement(ProposalVotingSectionComponent, null);
        }
    };
    const handleScroll = (event) => {
        const scrolled = event.currentTarget.scrollTop;
        if (scrolled > scrollTop) {
            setShowBottomBar(false);
        }
        else {
            setShowBottomBar(false);
            //      setShowBottomBar(true);
        }
        setScrollTop(scrolled);
        if (event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1 >
            event.currentTarget.scrollHeight) {
            //      setShowBottomBar(true);
            setShowBottomBar(false);
        }
    };
    const checkKeysForChain = (chain) => {
        if (!(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.keys))
            return false;
        const keys = activeAccount.keys;
        const chainLower = chain.toLowerCase();
        // Controlla se ha almeno una chiave (posting/active/owner)
        const rolesToCheck = ['posting', 'active', 'owner'];
        for (const role of rolesToCheck) {
            let key = null;
            if (chainLower === 'hive') {
                key = keys[`${role}hive`];
            }
            else if (chainLower === 'blurt') {
                key = keys[`${role}blurt`];
            }
            else if (chainLower === 'time') {
                key = null;
            }
            else if (chainLower === 'steem') {
                key = keys[role];
            }
            if (key)
                return true;
        }
        return false;
    };
    return (React.createElement("div", { className: 'home-page', "data-testid": `${Screen.HOME_PAGE}-page` },
        activeAccount &&
            activeAccount.name &&
            activeRpc &&
            activeRpc.uri !== 'NULL' && (React.createElement(React.Fragment, null,
            React.createElement(TopBarComponent, { onRefresh: () => setRefreshTrigger(prev => prev + 1) }),
            React.createElement("div", { key: `${currentChain}-${currentDiv1}-${currentDiv2}-${refreshTrigger}`, className: 'home-page-content', onScroll: handleScroll },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Chain"),
                            React.createElement("th", null,
                                "1",
                                React.createElement("sup", null, "st"),
                                " Currency"),
                            React.createElement("th", null,
                                "2",
                                React.createElement("sup", null, "nd"),
                                " Currency"))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement(BlockchainSwitcherComponent, null)),
                            React.createElement("td", null,
                                React.createElement(Div1SwitcherComponent, null)),
                            React.createElement("td", null,
                                React.createElement(Div2SwitcherComponent, null))),
                        React.createElement("tr", null,
                            React.createElement("td", { style: { textAlign: 'left' } },
                                React.createElement("div", { style: {
                                        background: '#f5f5f5',
                                        padding: '8px 8px',
                                        borderRadius: '6px',
                                        display: 'inline-block',
                                        maxWidth: '90%',
                                        marginLeft: '12px',
                                        textAlign: 'left'
                                    } },
                                    React.createElement("strong", null, rpcUrl.replace('https://', '') || 'Loading...'))),
                            React.createElement("td", { colSpan: 2, style: { textAlign: 'left', padding: '8px 0' } },
                                React.createElement("button", { onClick: () => {
                                        setSelectedOp(null);
                                        setFormData({});
                                        setExecResult(null);
                                        setExecError(null);
                                        setShowOperationModal(true);
                                    }, disabled: !hasKeyForChain, style: {
                                        background: '#f5f5f5',
                                        borderWidth: 2,
                                        borderColor: hasKeyForChain ? '#3fb950' : '#555',
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                        fontWeight: 'bold',
                                        cursor: hasKeyForChain ? 'pointer' : 'not-allowed',
                                    } }, hasKeyForChain
                                    ? `Exec Ops on ${currentChain}`
                                    : `No keys for ${currentChain}`))))),
                React.createElement(ResourcesSectionComponent, { activeAccount: activeAccount }),
                React.createElement(WalletInfoSectionComponent, null)))),
        showOperationModal && (React.createElement("div", { style: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement("div", { style: { background: '#161b22', color: '#e6edf3', padding: '24px', borderRadius: '12px', width: '90%', maxWidth: '620px', maxHeight: '90vh', overflowY: 'auto' } },
                React.createElement("h3", null,
                    "Exec Operation On ",
                    currentChain),
                React.createElement("button", { onClick: () => {
                        setShowOperationModal(false);
                        setSelectedOp(null);
                        setFormData({});
                        setExecResult(null);
                        setExecError(null);
                    }, style: { background: '#EFEFEF', color: 'black', padding: '14px', width: '100%', border: 'none', borderRadius: '8px', marginTop: '8px' } }, "Back"),
                React.createElement("select", { value: (selectedOp === null || selectedOp === void 0 ? void 0 : selectedOp.operation) || '', onChange: (e) => {
                        const ops = getCurrentOperations(currentChain);
                        const op = ops.find((o) => o.operation === e.target.value);
                        setSelectedOp(op);
                        setFormData({});
                        setExecResult(null);
                        setExecError(null);
                    }, style: { width: '100%', padding: '12px', margin: '15px 0', background: '#0d1117', color: '#e6edf3', border: '1px solid #30363d', borderRadius: '6px' } },
                    React.createElement("option", { value: "" }, "Select Operation..."),
                    getCurrentOperations(currentChain).map((op) => (React.createElement("option", { key: op.operation, value: op.operation }, formatName(op.operation))))),
                selectedOp && (React.createElement("div", null,
                    React.createElement("table", { style: { width: '100%', borderCollapse: 'collapse', margin: '15px 0' } },
                        React.createElement("thead", null,
                            React.createElement("tr", { style: { background: '#21262d' } },
                                React.createElement("th", { style: { padding: '10px', textAlign: 'left', borderBottom: '1px solid #30363d' } }, "Parameter"),
                                React.createElement("th", { style: { padding: '10px', textAlign: 'left', borderBottom: '1px solid #30363d' } }, "Value"))),
                        React.createElement("tbody", null, selectedOp.params.map((param) => (React.createElement("tr", { key: param, style: { borderBottom: '1px solid #30363d' } },
                            React.createElement("td", { style: { padding: '12px 10px', fontWeight: 'bold', verticalAlign: 'top' } }, formatName(param)),
                            React.createElement("td", { style: { padding: '8px 10px' } },
                                React.createElement("input", { type: "text", value: formData[param] || '', onChange: (ev) => setFormData(prev => (Object.assign(Object.assign({}, prev), { [param]: ev.target.value }))), placeholder: param, style: {
                                        width: '100%',
                                        padding: '10px',
                                        background: '#0d1117',
                                        color: '#e6edf3',
                                        border: '1px solid #30363d',
                                        borderRadius: '6px'
                                    } }))))))),
                    React.createElement("button", { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            setExecResult(null); // reset
                            setExecError(null); // reset
                            if (!(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name) || !selectedOp) {
                                setExecError("Account or Operation invalid");
                                return;
                            }
                            setIsExecuting(true);
                            const tmsmp = Date.now();
                            try {
                                const chainLower = currentChain.toLowerCase();
                                const lib = currentChain === 'STEEM' ? steem : currentChain === 'HIVE' ? hive : blurt;
                                // 1. RPC corretto
                                const rpcUrl = yield getDefVal(`${chainLower}_api`);
                                if (rpcUrl) {
                                    lib.api.setOptions({ url: rpcUrl });
                                }
                                // 2. Chiave corretta in base al ruolo
                                const requiredRole = selectedOp.roles[0]; // "posting", "active", "owner"
                                let privateKey = null;
                                if (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.keys) {
                                    const keys = activeAccount.keys; // ← Type assertion per bypassare TS
                                    if (chainLower === 'hive') {
                                        privateKey = keys[`${requiredRole}hive`] || keys[requiredRole];
                                    }
                                    else if (chainLower === 'blurt') {
                                        privateKey = keys[`${requiredRole}blurt`] || keys[requiredRole];
                                    }
                                    else {
                                        privateKey = keys[requiredRole];
                                    }
                                }
                                if (!privateKey) {
                                    throw new Error(`Key ${requiredRole} not present for ${currentChain}`);
                                }
                                // 3. Esecuzione
                                let methodName = selectedOp.operation;
                                let method = lib.broadcast[methodName];
                                if (typeof method !== 'function') {
                                    methodName = toCamelCase(selectedOp.operation);
                                    method = lib.broadcast[methodName];
                                    if (typeof method !== 'function') {
                                        throw new Error(`Operation "${selectedOp.operation}" not supported on ${currentChain}`);
                                    }
                                }
                                //                      const params = selectedOp.params.map((p: string) => formData[p] || '');
                                const operationPayload = {};
                                selectedOp.params.forEach((p) => {
                                    const value = (formData[p] || '').trim();
                                    if (!value) {
                                        operationPayload[p] = '';
                                        return;
                                    }
                                    if (value === '[]') {
                                        operationPayload[p] = [];
                                        return;
                                    }
                                    if (value != '[]' && value.startsWith('[') && value.endsWith(']')) {
                                        operationPayload[p] = JSON.parse(value);
                                        return;
                                    }
                                    if (p.toLowerCase().endsWith('id')) {
                                        const num = parseInt(value, 10);
                                        operationPayload[p] = isNaN(num) ? value : num;
                                        return;
                                    }
                                    operationPayload[p] = value;
                                    return;
                                });
                                const params = Object.values(operationPayload);
                                let response;
                                response = yield new Promise((resolve, reject) => {
                                    method(privateKey, ...params, (err, res) => {
                                        err ? reject(err) : resolve(res);
                                    });
                                });
                                const successMsg = `${selectedOp.operation} succesfully completed!`;
                                setExecResult(successMsg);
                                const reso = JSON.stringify(response);
                                // console.log('response: ', response);
                                yield saveOperationResult(tmsmp, 'Ok', reso, 'Successful', successMsg, {
                                    block_num: response.block_num,
                                    id: response.id,
                                    ref_block_num: response.ref_block_num,
                                    ref_block_prefix: response.ref_block_prefix,
                                    trx_num: response.trx_num,
                                    operations: undefined,
                                }, {
                                    site: 'GrapheneKeychainWeb',
                                    action: selectedOp.operation,
                                    keytype: requiredRole,
                                    username: activeAccount.name,
                                    chain: currentChain,
                                    operation: selectedOp.operation,
                                });
                            }
                            catch (err) {
                                const errorMsg = err.message || String(err);
                                setExecError(errorMsg);
                                yield saveOperationResult(tmsmp, 'Ko', '', 'Error', errorMsg, undefined, {
                                    site: 'GrapheneKeychainWeb',
                                    action: selectedOp.operation,
                                    keytype: selectedOp.roles[0],
                                    username: activeAccount.name,
                                    chain: currentChain,
                                    operation: selectedOp.operation,
                                });
                            }
                            finally {
                                setIsExecuting(false);
                            }
                        }), disabled: isExecuting, style: { background: '#3fb950', color: 'white', padding: '14px', width: '100%', border: 'none', borderRadius: '8px', marginTop: '8px' } }, isExecuting ? 'Executing...' : 'Exec Operation'))),
                (execResult || execError) && (React.createElement("div", { style: {
                        marginTop: '10px',
                        padding: '16px',
                        borderRadius: '8px',
                        background: execResult ? '#1f2a1f' : '#2a1f1f',
                        border: execResult ? '1px solid #3fb950' : '1px solid #ff6b6b'
                    } }, execResult ? (React.createElement("div", { style: { color: '#3fb950', fontWeight: 'bold' } },
                    "\u2705 Success",
                    React.createElement("pre", { style: {
                            background: '#0d1117',
                            padding: '12px',
                            marginTop: '8px',
                            borderRadius: '6px',
                            overflowX: 'auto',
                            whiteSpace: 'pre-wrap'
                        } }, `Operation ${selectedOp.operation} successfully executed on ${currentChain}`))) : (React.createElement("div", { style: { color: '#ff6b6b', fontWeight: 'bold' } },
                    "\u274C Error",
                    React.createElement("p", { style: { marginTop: '8px' } }, execError)))))))),
        renderPopup(displayWhatsNew, displayWrongKeyPopup, vestingRoutesDifferences),
        React.createElement(TutorialPopupComponent, null)));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        accounts: state.steem.accounts,
        activeRpc: state.steem.activeRpc,
        globalProperties: state.steem.globalProperties,
        isAppReady: Object.keys(state.steem.globalProperties).length > 0 &&
            !ActiveAccountUtils.isEmpty(state.steem.activeAccount),
    };
};
const connector = connect(mapStateToProps, {
    loadCurrencyPrices,
    refreshActiveAccount,
    resetTitleContainerProperties,
    setSuccessMessage,
});
export const HomeComponent = connector(Home);
